import { logAction, useRelodeReducer } from "@relode/core";
import * as React from "react";

import { useClientPublicJobActions } from "./clientPublicJobActions";
import { useClientPublicJobHandlers } from "./clientPublicJobHandlers";
import { clientPublicJobReducer } from "./clientPublicJobReducer";
import {
    ClientPublicJobState,
    defaultClientPublicJobState,
} from "./clientPublicJobState";

const ClientPublicJobContext = React.createContext<{
    state: ClientPublicJobState;
    actions: ReturnType<typeof useClientPublicJobActions>;
}>(undefined);

export const ClientPublicJobProvider = (props: {
    children: React.ReactNode;
}) => {
    const [state, dispatch] = useRelodeReducer(
        clientPublicJobReducer,
        defaultClientPublicJobState,
        [logAction]
    );

    const actions = useClientPublicJobActions(state, dispatch);
    useClientPublicJobHandlers(state, actions);
    const value = {
        state,
        actions,
    };

    return (
        <ClientPublicJobContext.Provider
            value={value}
            children={props.children}
        />
    );
};

export const useClientPublicJobContext = () => {
    const ctx = React.useContext(ClientPublicJobContext);
    if (!ctx) {
        throw new Error(
            "useClientPublicJobContext can only be used within a JobProvider"
        );
    }

    return ctx;
};
